import React, { useCallback, useEffect } from 'react';
import { ChangePlanParams } from 'api/billing/types';
import { PageLoading } from 'components/atoms/loading';
import { useChangePlanCheckoutMutation } from 'queries/billing';
import { loadChargebeeJS } from './chargebee';

interface Props {
  changePlanParams: ChangePlanParams;
  onSuccess?: () => void;
  onDismiss?: () => void;
}

export const BillingCheckout = ({
  changePlanParams,
  onSuccess,
  onDismiss,
}: Props) => {
  const { mutateAsync: changePlanCheckout } = useChangePlanCheckoutMutation();

  const openCheckout = useCallback(async () => {
    const instance = await loadChargebeeJS();

    instance.openCheckout({
      hostedPage: async () => changePlanCheckout(changePlanParams),
      success: async () => {
        onSuccess?.();
      },
      close: () => {
        onDismiss?.();
      },
    });
  }, [changePlanCheckout, changePlanParams, onDismiss, onSuccess]);

  useEffect(() => {
    openCheckout();
  }, [openCheckout]);

  return (
    <>
      <div className="ant-modal-mask">
        <PageLoading css light />
      </div>
    </>
  );
};
